/**
 *
 */
export class Ecc11 {
  name = '';

  /**
   *constructor
   *
   */
  constructor() {
    this.name = '';
  }
}
